export type RecommendedArticleInputParams = {
  pathology?: string | null;
  bodyArea?: string | null;
  experienceType?: string | null;
  techno?: string | null;
  excludeId?: string | null;
  index?: string | null;
};

const makeQueryString = ({
  bodyArea,
  experienceType,
  pathology,
  techno,
  excludeId,
  index,
}: RecommendedArticleInputParams) => {
  const params: string[] = [];
  bodyArea && params.push(`bodyArea=${bodyArea}`);
  experienceType && params.push(`experienceType=${experienceType}`);
  pathology && params.push(`pathology=${pathology}`);
  techno && params.push(`techno=${techno}`);
  excludeId && params.push(`excludeId=${excludeId}`);
  index && params.push(`index=${index}`);
  const queryString = params.join('&');
  return queryString;
};

export const getRecommendedArticles = async ({
  bodyArea,
  experienceType,
  pathology,
  techno,
  excludeId,
  index,
}: RecommendedArticleInputParams) => {
  const queryString = makeQueryString({
    bodyArea,
    experienceType,
    pathology,
    techno,
    excludeId,
    index,
  });

  try {
    const response = await fetch(`/.netlify/functions/recomendedArticle?${queryString}`);
    const data = await response.json();
    return data.result;
  } catch (error) {
    console.log('error in getRecommandedArticle: ', error);
  }
};
